// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_AT_RULE_IMPORT_0___ from "-!../../../../node_modules/css-loader/dist/cjs.js!./arrows.css";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
___CSS_LOADER_EXPORT___.i(___CSS_LOADER_AT_RULE_IMPORT_0___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `:host {
    font-family: var(--p2-regular-font-family);
    font-size: var(--p2-regular-font-size);
    letter-spacing: var(--p2-regular-letter-spacing);
    line-height: var(--p2-regular-line-height);
    font-weight: var(--p2-regular-font-weight);
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: space-around;
}

:host > div {
    display: flex;
    flex-direction: row;
    align-items: center;
}
:host > div > div {
    margin-right: var(--spacing-20);
}

ul.swiftref-pagination {
    list-style-type: none;
    margin: 0;
    padding: 0;
    overflow: hidden;
    display: flex;
    user-select: none;
    align-items: center;
}

ul.swiftref-pagination li {
    color: var(--accent-strong-default);
    display: inline-block;
    margin: 0 4px;
    padding: 7px 1px;
    border: none;
    min-width: 20px;
    text-align: center;
}
ul.swiftref-pagination li.previous,
ul.swiftref-pagination li.next {
    border-radius: 5px;
}
ul.swiftref-pagination li.current {
    color: var(--text-default);
    background: var(--accent-light-default);
    border-radius: 5px;
}
:host(:not([disabled])) ul.swiftref-pagination li:not(.current):not(.disabled):hover,
ul.swiftref-pagination:not(.disabled) li:not(.current):not(.disabled):hover {
    cursor: pointer;
    background: var(--accent-light-hover);
}
ul.swiftref-pagination li.current:hover {
    cursor: default;
}
ul.swiftref-pagination li.disabled {
    opacity: .8;
}
ul.swiftref-pagination li.disabled:hover {
    cursor: default;
}
ul.swiftref-pagination li.previous.disabled:hover,
ul.swiftref-pagination li.next.disabled:hover{
    cursor: not-allowed;
    background: none;
}


:host([disabled]) ul.swiftref-pagination li{
    cursor: not-allowed;
    opacity: .6;
}
`, "",{"version":3,"sources":["webpack://./../website_design_system/src/components/pagination/style/index.css"],"names":[],"mappings":"AAEA;IACI,0CAA0C;IAC1C,sCAAsC;IACtC,gDAAgD;IAChD,0CAA0C;IAC1C,0CAA0C;IAC1C,aAAa;IACb,mBAAmB;IACnB,mBAAmB;IACnB,6BAA6B;AACjC;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,mBAAmB;AACvB;AACA;IACI,+BAA+B;AACnC;;AAEA;IACI,qBAAqB;IACrB,SAAS;IACT,UAAU;IACV,gBAAgB;IAChB,aAAa;IACb,iBAAiB;IACjB,mBAAmB;AACvB;;AAEA;IACI,mCAAmC;IACnC,qBAAqB;IACrB,aAAa;IACb,gBAAgB;IAChB,YAAY;IACZ,eAAe;IACf,kBAAkB;AACtB;AACA;;IAEI,kBAAkB;AACtB;AACA;IACI,0BAA0B;IAC1B,uCAAuC;IACvC,kBAAkB;AACtB;AACA;;IAEI,eAAe;IACf,qCAAqC;AACzC;AACA;IACI,eAAe;AACnB;AACA;IACI,WAAW;AACf;AACA;IACI,eAAe;AACnB;AACA;;IAEI,mBAAmB;IACnB,gBAAgB;AACpB;;;AAGA;IACI,mBAAmB;IACnB,WAAW;AACf","sourcesContent":["@import \"arrows.css\";\n\n:host {\n    font-family: var(--p2-regular-font-family);\n    font-size: var(--p2-regular-font-size);\n    letter-spacing: var(--p2-regular-letter-spacing);\n    line-height: var(--p2-regular-line-height);\n    font-weight: var(--p2-regular-font-weight);\n    display: flex;\n    flex-direction: row;\n    align-items: center;\n    justify-content: space-around;\n}\n\n:host > div {\n    display: flex;\n    flex-direction: row;\n    align-items: center;\n}\n:host > div > div {\n    margin-right: var(--spacing-20);\n}\n\nul.swiftref-pagination {\n    list-style-type: none;\n    margin: 0;\n    padding: 0;\n    overflow: hidden;\n    display: flex;\n    user-select: none;\n    align-items: center;\n}\n\nul.swiftref-pagination li {\n    color: var(--accent-strong-default);\n    display: inline-block;\n    margin: 0 4px;\n    padding: 7px 1px;\n    border: none;\n    min-width: 20px;\n    text-align: center;\n}\nul.swiftref-pagination li.previous,\nul.swiftref-pagination li.next {\n    border-radius: 5px;\n}\nul.swiftref-pagination li.current {\n    color: var(--text-default);\n    background: var(--accent-light-default);\n    border-radius: 5px;\n}\n:host(:not([disabled])) ul.swiftref-pagination li:not(.current):not(.disabled):hover,\nul.swiftref-pagination:not(.disabled) li:not(.current):not(.disabled):hover {\n    cursor: pointer;\n    background: var(--accent-light-hover);\n}\nul.swiftref-pagination li.current:hover {\n    cursor: default;\n}\nul.swiftref-pagination li.disabled {\n    opacity: .8;\n}\nul.swiftref-pagination li.disabled:hover {\n    cursor: default;\n}\nul.swiftref-pagination li.previous.disabled:hover,\nul.swiftref-pagination li.next.disabled:hover{\n    cursor: not-allowed;\n    background: none;\n}\n\n\n:host([disabled]) ul.swiftref-pagination li{\n    cursor: not-allowed;\n    opacity: .6;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
